import { Component, OnInit } from '@angular/core';
import { FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaRefService } from 'src/app/Service/DeviceBehfa/DeviceBehfaRef.service';
import { FlowcharPaperService } from 'src/app/Service/Flowchart/FlowcharPaper.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import { DeviceBehfaRef_Interface, Empty_DeviceBehfaRef_Interface } from 'src/app/Interface/DeviceBehfaRef_Interface';

@Component({
  selector: 'app-DeviceBehfaRef',
  templateUrl: './DeviceBehfaRef.component.html',
  styleUrls: ['./DeviceBehfaRef.component.css']
})
export class DeviceBehfaRefComponent implements OnInit {

  BaseUrl1:string=""
  BaseUrlCo:string="&id2="
  page:number=0;
  Procssing:boolean=false



  StartSearchDate:string=''
  EndSearchDate:string=''
  SubmitPeriodDate:string='0'
  Filter_Status:string='0'
  Filter_BehfaCode:string=""
  Filter_title:string=""



  FormTypeShow:string='List'
  
  modalRef_Delete: any;

  constructor(
    private FlowcharPaper_Service:FlowcharPaperService,
    private DeviceBehfaRef_Service:DeviceBehfaRefService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  DataList_DeviceBehfa:Array<DeviceBehfaRef_Interface>=[]
  DataList_History:Array<FlowchartPaper_History_Interface>=[]
  Selected_DeviceBehfa_Record:  DeviceBehfaRef_Interface=Empty_DeviceBehfaRef_Interface();

  ngOnInit() {
    this.BaseUrl1 =  environment.BaseUrl+"flowchart/WorkflowDetail?id="
    this.Nav_Service.CheckValidPage(2214).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

    
  }

  ReadData_DeviceBehfa(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.DeviceBehfaRef_Service.GetRecord(Number(this.SubmitPeriodDate),
      Number(this.Filter_Status),
      this.Filter_BehfaCode,
      this.Filter_title,
      StartSearchDate,
      EndSearchDate,
    ).subscribe(
      data=>{

        this.DataList_DeviceBehfa=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }


  
  ReadData_History(item:DeviceBehfaRef_Interface){
    this.Procssing=true
    this.FlowcharPaper_Service.History_WorkFlow(item.flowchart.makerId).subscribe(
      data=>{
        this.Selected_DeviceBehfa_Record=item
        this.DataList_History=data
        this.FormTypeShow='List'
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ReadData_Form(item:DeviceBehfaRef_Interface){
    this.Selected_DeviceBehfa_Record=item

    this.FormTypeShow='Form'
  }

  ReadData_View(item:DeviceBehfaRef_Interface){
    this.Selected_DeviceBehfa_Record=item

    this.FormTypeShow='View'
  }

  Close_Show_History(){
    this.Selected_DeviceBehfa_Record=Empty_DeviceBehfaRef_Interface()
    this.FormTypeShow='List'
  }


}
